// The only place a Firestore ref is built (data-access brief, section 3).
// Pure: takes db as an argument and imports nothing, so it loads under node --test.

// Every subcollection a project (and a version) carries. Replaces the hand-written
// lists as later slices migrate the copy and delete paths.
export const PROJECT_SUBCOLLECTIONS = ['cues', 'layers', 'notes', 'scriptMarkers'];

export const userDoc = (db, uid) => db.collection('users').doc(uid);
export const projectDoc = (db, pid) => db.collection('projects').doc(pid);


// WEBPACK FOOTER //
// ./src/data/paths.js